import { type ComponentProps, type FC, useCallback, useEffect, useState } from 'react';

import { CheckmarkIcon, CopyIcon } from '../icons';
import { IconButton } from './button/IconButton';

type TextProps = { text: string };
type HtmlProps = { html: string };

type Props = ComponentProps<typeof IconButton> &
	Partial<TextProps & HtmlProps> &
	(TextProps | HtmlProps);

export const ClipboardButton: FC<Props> = ({ html, text, ...props }) => {
	const writeToClipboard = useCallback(async () => {
		const content: ConstructorParameters<typeof ClipboardItem>[0] = {};

		if (text) {
			content['text/plain'] = text;
		}

		if (html) {
			content['text/html'] = html;
		}

		const item = new ClipboardItem(content);
		await navigator.clipboard.write([item]);
	}, [text, html]);

	const [confirm, setConfirm] = useState(false);

	useEffect(() => {
		if (confirm) {
			setTimeout(() => {
				setConfirm(false);
			}, 1000);
		}
	}, [confirm]);

	return (
		<IconButton
			type="plain"
			flexShrink={0}
			{...props}
			icon={confirm ? <CheckmarkIcon /> : <CopyIcon />}
			onClick={async () => {
				await writeToClipboard();
				setConfirm(true);
			}}
		/>
	);
};
